
import React from 'react';

export const Areas = ({areas,onFetchArea }) => {

    const returnWidth = (area) => {
        let { totalAssets, totalCompletedAssets } = area;

        if (totalAssets !== 0) {
            if (totalAssets === totalCompletedAssets) {
                return '100%'
            }
            else {
                let width = totalCompletedAssets / totalAssets * 100
                width = width.toString() + '%';
                return width;
            }
        }
        else {
            return '0%'
        }
    }

    return (
        <div class="bad_main">
    {areas && areas.length > 0 ? areas.map(area =>
        <div class="line_red_main"
            onClick={() => onFetchArea(area)}
        >
            <div class="dedroom_box">
                <div class="dedroom_text">
                    <h6>{area.customLabel ? area.customLabel : area.name}</h6>
                </div>
                <div class="assets d-flex align-items-center justify-content-between">
                    <span className='assetName'>Assets</span>
                    <span className="f-right">{area.totalCompletedAssets + "/" + area.totalAssets}</span>
                </div>
                <div class="assets assets_none d-flex align-items-center justify-content-between">
                    <span className='assetName'>Issue</span>
                    <span className="f-right">{area.issuesCreated}</span>
                </div>
            </div>
            <div class="line_red" style={{ width: returnWidth(area), height: 8 }}></div>
        </div>
    ) : null}
</div>
    )
}